import { getKycInfo } from "@/api/modules/auth"
import { getRegId, setRegId, removeRegId, getUserId } from "@/utils/auth"
/**
 * 验证相关
 */
export default {
  state: {
    step: '0',
    regId: getRegId(),
    registerInfo: null
  },
  mutations: {
    SET_STEP(state, payload = '0') {
      state.step = payload
    },
    SET_REGISTER_INFO(state, payload) {
      state.registerInfo = payload
    },
    SET_REG_ID(state, payload = null) {
      state.regId = payload
    },
  },
  actions: {
    async setStep({ commit }, payload) {
      const userId = getUserId()
      if (!userId) return
      const { step = '0' } = (payload ? { step: payload } : await getKycInfo({ userId }))
      commit('SET_STEP', step)
    },
    async getAcctReviewStatus({ commit }, userId = getUserId()) {
      try {
        if (!userId) return
        const userAuthDetailRes = await getKycInfo({ userId })
        commit('SET_STEP', userAuthDetailRes.step || '0')
        commit('SET_REGISTER_INFO', userAuthDetailRes)
      } catch (err) {
        console.log(`%c ${'error'}`, 'color:#f00', err)
      }
    },
    setRegId({ commit }, regId) {
      setRegId(regId)
      commit('SET_REG_ID', regId)
    }
  }
}
